import {useNavigate} from "react-router-dom";

import {TextLink} from "base/navigation/components";
import {SectionFieldEditButton, SectionFieldHelpText, SectionValueBox} from ".";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const Unit = ({unit}) => {
    return (
        <Typography
            variant="subtitle1"
            component="span"
            sx={{
                lineHeight: {xs: 1.85, sm: 1.65},
                ml: 1,
                overflowWrap: "break-word",
                whiteSpace: "pre-line;",
                fontSize: "0.8em",
                color: "grey",
            }}
        >
            {unit}
        </Typography>
    );
};

const SectionField = ({
    label = null,
    value = null,
    unit = "",
    labelIcon = null,
    containerWidth = "",
    textAlign = "left",
    valueCustomStyle = {},
    linkPath = null,
    editButton = false,
    editButtonPath = "",
    helperText = "",
    tooltipText = null,
    hideValueBox = false,
    longField = false,
}) => {
    const navigate = useNavigate();
    let labelWidth;
    let valueWidth;

    switch (`${containerWidth}`) {
        case "long":
            labelWidth = 9;
            valueWidth = editButton ? 2 : 3;
            break;
        case "short":
            labelWidth = editButton ? 5 : 6;
            valueWidth = 6;
            break;
        default:
            labelWidth = 5;
            valueWidth = editButton ? 6 : 7;
            break;
    }

    const valueStyle = {
        mt: {xs: 0, sm: 1.5},
        overflowWrap: "break-word",
        lineHeight: {xs: 1.5, sm: 1.25},
        fontWeight: "regular",
        whiteSpace: longField ? "pre-line" : "normal",
        ...valueCustomStyle,
    };

    const getValueToDisplay = () => {
        if (value === true) return "Sim";
        if (value === false) return "Não";
        else return value;
    };

    const regularField = (
        <>
            <Typography variant="subtitle2" component="span" sx={valueStyle}>
                {getValueToDisplay()}
            </Typography>
            {helperText && <SectionFieldHelpText text={helperText} />}
            {unit && <Unit unit={unit} />}
        </>
    );

    const linkField = (
        <TextLink
            text={getValueToDisplay()}
            to={linkPath}
            textStyle={{fontSize: "14px"}}
        />
    );

    const LabelIcon = labelIcon;
    const isValueValid = value || value === 0 || typeof value === "boolean";
    const typeOfField = linkPath ? linkField : regularField;

    return (
        <Grid container columnSpacing={containerWidth === "long" ? 2 : 1} sx={{my: 1}}>
            <Grid
                item
                container
                flexWrap={tooltipText ? "nowrap" : "wrap"}
                xs="auto"
                sm={5}
                lg={labelWidth}
                alignItems={tooltipText ? "center" : "flex-start"}
                alignContent="center"
            >
                {tooltipText && (
                    <Tooltip title={tooltipText} arrow enterDelay={500}>
                        <InfoOutlinedIcon
                            sx={{mr: 1, color: "grey.500", fontSize: "0.9rem"}}
                        />
                    </Tooltip>
                )}
                {labelIcon && (
                    <LabelIcon fontSize="small" sx={{mr: 1, color: "text.secondary"}} />
                )}
                {label && (
                    <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{
                            lineHeight: {xs: 1.5, sm: 1.25},
                            hyphens: "auto",
                        }}
                    >
                        {label}:
                    </Typography>
                )}
            </Grid>
            <Grid
                item
                container
                xs="auto"
                sm={6}
                lg={valueWidth}
                alignItems="flex-end"
                alignContent="center"
                sx={{textAlign: textAlign}}
            >
                {hideValueBox ? (
                    value
                ) : (
                    <SectionValueBox value={isValueValid ? typeOfField : null} />
                )}
                {editButton ? (
                    <Grid item xs={1}>
                        <SectionFieldEditButton onClick={navigate(editButtonPath)} />
                    </Grid>
                ) : null}
            </Grid>
        </Grid>
    );
};

export default SectionField;
